/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, pxToRem, themeV2, coloredScrollBar } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION ADMIN SECTION : STYLES --------------- ++++++++++ */
export default theme => ({
  '@global': {
    '.modalpage': { 
      width: '90%',
      maxWidth: '900px !important',
      borderRadius: pxToEm(12),
      '& .close': {
        border: 'none',
        '& .icon': {
          color: '#061240'
        }
      }
    },
    '.addproductgroupmodal': {
      '& .configcontainer': {
        extend: coloredScrollBar(themeV2.color.base.scrollbar),
        padding: pxToEm(8),
        paddingTop: 0,
        height: 'calc(80vh - 90px)',
        width: '900px',
        overflowY: 'auto',
        '& .sortablelist': {
          '& > div > div': {
            top: 'unset !important',
            left: 'unset !important',
            position: 'relative !important'
          },
        },
      },
      '&.INLINE': {
        '& .previewconfig > .content': {
          // height: 'calc(80vh - 90px)'
          // height: 'auto'
        }
      },
      '&.SIDE_PANEL_LEFT, &.SIDE_PANEL_RIGHT': {
        '& .previewconfig > .content': {
          height: 'auto'
        }
      },
      '&.OVERLAY': {
        '& .previewconfig > .content': {
          maxHeight: 'calc(80vh - 80px)'
        }
      },
      '& > h4': {
        borderBottom: '3px solid #000',
        paddingBottom: pxToEm(8),
      },
      '& .header': {
        width: '100% !important',
      },
      fontSize: pxToEm(14),
      padding: pxToEm(14),
      '& .actionbuttons button': { width: '100%'},
      '& h4': {
        marginBottom: pxToEm(20),
        fontSize: '20px'
      },
      '& .changelist': {
        textAlign: 'left',
        margin: `${pxToEm(16)} ${pxToEm(24)}`,
      },
      '& ul': {
        margin: pxToEm(8),
        marginBottom: pxToEm(16),
        color: themeV2.color.base.gray.dark,
        '& li': {
          textAlign: 'left',
          marginLeft: pxToEm(16)
        }
      },
      '& .errormessage': {
        display: 'block',
        color: themeV2.color.error.main
      },
      '& .sectiongroupv2': {
        width: '100% !important'
      },
      '& .previewconfig > .content': {
        padding: 0,
        background: '#DFDFDF'
      },
      '& .previewconfig': {
        height: 'fit-content'
      },
      '& h5': {
        fontWeight: 300,
        fontSize: pxToEm(14)
      }
    }
  }
});
